/* unplugin-vue-components disabled */import script from "./CreateCaseDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCaseDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateCaseDialog.vue?vue&type=style&index=0&id=c3397d2c&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上电-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3397d2c"]])

export default __exports__